import { useMemo } from "react";

import { useHistory } from "../../../../../../../reactQuery/worklog";
import { getResponseData } from "../../../../../../../reactQuery/response";
import { sortByDateDescending } from "../../hooks/commentUtils";

export function useDetailHistoryItems(cardId) {
  const { isLoading, history } = useHistory(cardId);

  const sortedHistory = useMemo(
    () => sortByDateDescending(getResponseData(history, []), "at_time"),
    [history]
  );

  return {
    isLoading,
    sortedHistory,
  };
}
